import { z } from 'zod';

export const SopSectionSchema = z.object({
  chapterName: z.string(),
  reasonIds: z.array(z.string()).nullish(),
  description: z.string(),
});

export const SopSchema = z.object({
  id: z.string(),
  customId: z.string(),
  authorityId: z.string().nullish(),
  authorityName: z.string().nullish(),
  reasonName: z.string().nullish(),
  name: z.string(),
  content: z.string().nullish(),
  sopDetails: z.array(SopSectionSchema),
  version: z.string().nullish(),
  status: z.string(),
  createDate: z.string(),
  lastUpdateDate: z.string().nullish(),
});

export type Sop = z.infer<typeof SopSchema>;
export type SopSection = z.infer<typeof SopSectionSchema>;
